/** 정산주체 */
export enum AccountEntity {
  Mari = 'Mari',
  Gaon = 'Gaon',
  NotDecided = 'NotDecided',
}

export interface AccountConfig {
  _id: string;
  name: string; // 설정 이름 (관리용)
  accountEntity: AccountEntity; // 정산주체
  pgFeeRefund: boolean; // PG수수료 반환 여부
  createdAt: string;
  updatedAt: string;
}

export type AccountConfigCreate = Pick<
  AccountConfig,
  'name' | 'accountEntity' | 'pgFeeRefund'
>;

export type AccountConfigUpdate = {
  _id: string;
  name?: string;
  accountEntity?: AccountEntity;
  pgFeeRefund?: boolean;
};
